import { useCallback } from 'react';
import { redirectToPublicProfile } from '@/helpers/redirectToPublicProfile';
import { useNotification } from '@/hooks/useNotification';
import { usePublicTokenMutation } from '@/hooks/usePublicTokenMutation';
import { PUBLIC_URL } from '@/constants/app';

type RedirectToPublicProfileArgs = {
  returnToMpaUrl?: string;
};

export const useRedirectToPublicProfile = () => {
  const publicTokenMutation = usePublicTokenMutation();
  const { showErrorNotification } = useNotification();

  const redirectToPublicProfilePage = useCallback(
    async ({ returnToMpaUrl }: RedirectToPublicProfileArgs = {}): Promise<boolean> => {
      if (!PUBLIC_URL?.trim()) {
        showErrorNotification(new Error('Missing VITE_PUBLIC_URL configuration'));
        return false;
      }

      try {
        const { publicToken } = await publicTokenMutation.mutateAsync();
        if (!publicToken?.trim()) {
          showErrorNotification(new Error('Public token was not returned'));
          return false;
        }

        redirectToPublicProfile({
          publicToken,
          state: {
            returnToMpaUrl: returnToMpaUrl ?? window.location.href,
          },
        });
        return true;
      } catch (error) {
        showErrorNotification(error);
        return false;
      }
    },
    [publicTokenMutation, showErrorNotification]
  );

  return {
    redirectToPublicProfilePage,
    isRedirectPending: publicTokenMutation.isPending,
  };
};
